import { Injectable } from '@angular/core';
import { map, switchMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../../PRE-LOAD/app-settings';
import { Observable } from 'rxjs';
import { CalendarDay } from '../../types/date-and-times';
import { UserSelectionsService } from '../user-selections/user-selections.service';
import { environment } from '../../../../environments/environment';
import { ErrorService } from '../errors/error.service';
import { buildUrl } from '../../../../urls';
import { AuthService } from '../../auth/auth.service';

@Injectable({
    providedIn: 'root'
})
export class DatesService {
    constructor(
        private httpClient: HttpClient,
        private userSelectionService: UserSelectionsService,
        private appSettings: AppSettings,
        private errorService: ErrorService,
        private authService: AuthService) {
    }

    public getAvailableDates(isOffSite: boolean): Observable<CalendarDay[]> {

        return this.authService.getToken().pipe(switchMap((token) => {
            return this.getAvailableDatesWithToken(isOffSite, token);
        }));
    }


    private getAvailableDatesWithToken(isOffSite: boolean, token: String): Observable<CalendarDay[]> {
        let product = this.userSelectionService.get('product');

        let params:any = {
            brand: this.appSettings.apiBrand,
            retailerId: this.appSettings.retailerId,
            
            start: new Date().toJSON(),
            end: new Date(new Date().setDate(new Date().getDate() + 30)).toJSON(),
            startLocation: isOffSite ? 'OffSite' : 'OnSite',
            bookableId: product.id != null ? product.id : ""
        };

        if (product.modelTreeRef != null){
            params.modelTreeRef = product.modelTreeRef;
        }

        if (product.id != null && params.modelTreeRef == null){
            params.bookableId = product.id;
        }

        return this.httpClient.get(buildUrl(this.appSettings.realtimeEndpointUrl, `/api/availability`), {
            headers: { 'Authorization': `Bearer ${token}` },
            params
        }).pipe(
                map((res: any[]) => {
                    // console.log(res);
                    // Handle the API doing something silly.
                    if (!res) {
                        this.errorService.handleError({ statusCode: 400, url: '/api/availability', method: 'GET' });
                        return [];
                    }
                    return res.map((day: any): CalendarDay => {
                        return {
                            date: new Date(day.availableDate),
                            availableTimesCount: day.times.filter(timeObj => timeObj.available).length,
                            times: day.times.map((timeObj: any) => {
                                return {
                                    start_time: new Date(timeObj.startTime),
                                    end_time: new Date(timeObj.endTime),
                                    isAvailable: timeObj.available,
                                    bookableId: day.bookableId
                                };
                            })
                        };
                    });
                })
            );
    }

}
